import {
    Paper,
    Typography,
    Button,
} from "@mui/material";
import { useAppContext } from "../../context";


export default function VerifyError({ title, message, link }: { title: string, message: string, link?: string }) {
    const { setOpenPopUp } = useAppContext();
    return (

        <Paper
            elevation={0}
            sx={{
                width: "100%",
                maxWidth: 320,
                p: { xs: 2.5, sm: 4 },
                borderRadius: 3,
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            }}
        >
            <Typography
                variant="h5"
                fontWeight={700}
                mb={1}
                textAlign="center"
            >
                {title}
            </Typography>
            <Typography
                variant="body2"
                color="text.secondary"
                textAlign="center"
                mb={3}
            >
                {message}
                {link && (
                    <a href={link} target="_blank" rel="noopener noreferrer" style={{ display: "block", textAlign: "center", marginBottom: 16, color: "#0f6de0cc", fontWeight: 600 }}
                    >
                        {link}
                    </a>
                )}
            </Typography>

            <Button
                variant="contained"
                fullWidth
                sx={{
                    height: 45,
                    borderRadius: "10px",
                    background: "#FF5440"
                }}
                onClick={() => setOpenPopUp(false)}
            >
                დახურვა
            </Button>
        </Paper>

    );
}